import { render, staticRenderFns } from "./MessagesDrop.vue?vue&type=template&id=34b2e874&"
import script from "./MessagesDrop.vue?vue&type=script&lang=js&"
export * from "./MessagesDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports